import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { OpportunitiesCreateTaskToolbarAction } from "@/components/pages/common/opportunities/components/toolbar/OpportunitiesCreateTaskToolbarAction";
import { useAppSelector } from "@/store/hooks";
import { resourceDetailsTargetResourceIdSelector } from "@/store/resource-details/selectors/target-resource/resourceDetailsTargetResourceIdSelector";
import { savingsOpportunitiesDataLengthSelector } from "@/store/savings-opportunities/selectors/savingsOpportunitiesDataLengthSelector";
import { SavingsOpportunity } from "@/services/cloudchipr.api";
import { ResourceDetailsOpportunitiesContentCsv } from "@/components/pages/common/resource-details/components/content/opportunities-content/components/ResourceDetailsOpportunitiesContentCSV";

interface ResourceDetailsOpportunitiesGeneralContentToolbarProps {
  opportunities: SavingsOpportunity[];
}

export const ResourceDetailsOpportunitiesContentToolbar: FC<
  ResourceDetailsOpportunitiesGeneralContentToolbarProps
> = ({ opportunities }) => {
  const resourceId = useAppSelector(resourceDetailsTargetResourceIdSelector);

  const count = useAppSelector((state) =>
    savingsOpportunitiesDataLengthSelector(state, resourceId),
  );

  return (
    <Stack direction="row" justifyContent="space-between">
      {!!count && (
        <Typography variant="body2">
          {count} {count > 1 ? "Opportunities" : "Opportunity"}
        </Typography>
      )}

      <Stack
        direction="row"
        justifyContent="end"
        alignItems="center"
        spacing={2}
      >
        <Stack
          direction="row"
          borderRadius={2}
          bgcolor="grey.100"
          spacing={0.5}
        >
          <OpportunitiesCreateTaskToolbarAction opportunities={opportunities} />
        </Stack>

        <ResourceDetailsOpportunitiesContentCsv opportunities={opportunities} />
      </Stack>
    </Stack>
  );
};
